<template>
  <el-drawer
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    direction="rtl"
    size="900px"
    :before-close="handleClose"
  >
    <div v-loading="editLoading" class="tranWare_dialog_content">
      <el-form ref="form" :model="form">
        <!-- <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick"
        > -->
        <div v-show="activeName == 1">
          <formItem
            class="margin"
            :form="form"
            :field="tranWareFieldWareHouse.GOODS_RULE"
          >
            <template slot="customer">
              <!-- <el-select
                v-model="customerCodeID"
                class="inputStyle"
                filterable
                remote
                placeholder="请输入客户名称或客户企业信用代码搜索选择"
                :disabled="true"
                :remote-method="querySearchAsync"
                @change="handleCustomerSelect"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="custom-select">
                    <span>{{ item.customerName }}</span>
                    <span class="customerCodeText">{{ item.carrierTenantName }}</span>
                  </div>
                </el-option>
              </el-select> -->
              <el-input
                :value="`${customersDetail.customerName} (${customersDetail.carrierTenantName})`"
                placeholder="请输入客户名称或客户企业信用代码搜索选择"
                :disabled="true"
              />
            </template>
            <template slot="originalCustomer">
              <el-select
                v-model="originalCustomerID"
                class="inputStyle"
                filterable
                clearable
                remote
                placeholder="请输入原始客户名称或客户企业信用代码搜索选择"
                :remote-method="queryOriginalCustomer"
                @change="handleOriginalChange"
              >
                <el-option
                  v-for="item in originalCustomerOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                  <div class="custom-select">
                    <span>{{ item.customerName }}</span>
                    <span class="customerCodeText">{{ item.carrierTenantName }}</span>
                  </div>
                </el-option>
              </el-select>
            </template>
            <template slot="type">
              <el-radio-group
                v-model="form.type"
                class="tran_radio"
                size="small"
                @change="handelChangeType"
              >
                <el-radio
                  v-for="item in warehouseOptions"
                  :key="item.value"
                  :label="item.value"
                  border
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
          </formItem>
          <div class="tran_ware_path">
            <formItem title="转仓路径" />
            <el-table
              :data="form.warehouseTransferRuleList"
              stripe
              :max-height="240"
              class="tran_table"
            >
              <el-table-column
                label="顺序"
                type="index"
                width="72"
              />
              <el-table-column
                v-for="(item,index) in tableColumn"
                :key="index"
                :label="item.label"
                :prop="item.prop"
                v-bind="item"
                :min-width="item.minWidth"
              >
                <template slot-scope="scope">
                  <template v-if="item.prop === 'tenantId'">
                    <el-select
                      v-model="form.warehouseTransferRuleList[scope.$index][item.prop]"
                      :disabled="scope.$index===0?true:(form.customerCode||form.originalCustomerCode?false:true)"
                      filterable
                      remote
                      placeholder="请输入租户名称查询"
                      :remote-method="querySearchTenantAsync"
                      @change="(val)=>lineSelectChange(val,scope.$index)"
                      @focus="handleFocus(scope.$index)"
                    >
                      <el-option
                        v-for="val in tenantOptions"
                        :key="val.id"
                        :label="val.label"
                        :value="val.value"
                      >
                        <div class="custom-select">
                          <span>{{ val.label }}</span>
                          <span class="customerCodeText">{{ val.value }}</span>
                        </div>
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="item.prop==='contractCode'">
                    <el-select
                      v-model="form.warehouseTransferRuleList[scope.$index][item.prop]"
                      :disabled="form.warehouseTransferRuleList[scope.$index]['tenantId']?false:true"
                      filterable
                      placeholder="请选择合同"
                      @change="(val)=>chooseContractChange(val,scope.$index)"
                      @focus="handleContractFocus(scope.$index)"
                    >
                      <el-option
                        v-for="t in (contractObj[scope.$index].contractList||[])"
                        :key="t.contractCode"
                        :label="t.contractName"
                        :value="t.contractCode"
                      />
                    </el-select>
                    <!-- <div v-if="form.warehouseTransferRuleList[scope.$index]['tenantId']" style="height:20px;" /> -->
                  </template>
                  <template v-if="item.prop==='projectId'">
                    <el-select
                      v-model="form.warehouseTransferRuleList[scope.$index][item.prop]"
                      filterable
                      remote
                      clearable
                      placeholder="请选择运营项目"
                      :remote-method="(query)=>querySearchProject(query,scope.$index)"
                      @change="(val)=>handleChangeProject(val,scope.$index)"
                      @focus="handleProjectFocus(scope.$index)"
                    >
                      <el-option
                        v-for="t in (projectObj[scope.$index]?.projectList||[])"
                        :key="t.projectId"
                        :label="t.projectName"
                        :value="t.projectId"
                      />
                    </el-select>
                  </template>
                  <template v-if="item.prop==='active'">
                    <el-button
                      v-if="cancelFun(scope.$index)"
                      type="text"
                      size="small"
                      @click="handelDeleteLine(scope.$index)"
                    >
                      删除
                    </el-button>
                  </template>
                  <template v-else>
                    <span v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]" />
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <div class="add_bar" @click="handelAddLine">
              <span>
                <i class="el-icon-plus" />
                添加一行数据
              </span>
            </div>
          </div>
        </div>
        <div v-show="activeName == 2">
          <formItem
            :form="form"
            class="margin"
            :field="tranWareFieldWareHouse.ADDITIONAL_RULE"
          >
            <template slot="project">
              <el-select
                v-model="project"
                class="inputStyle"
                filterable
                clearable
                remote
                multiple
                placeholder="请选择运营项目"
                @change="handleProjectSelect"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="`${item.id}`"
                />
              </el-select>
            </template>
            <template slot="areas">
              <AddressCity
                v-model="areas"
                class="city-area"
                :level="2"
                :clearable="true"
                :props="{
                  multiple: true,
                  checkStrictly: true
                }"
                @changeCity="changeCity"
              />
            </template>
          </formItem>
          <div class="link_footer">
            <h4>规则释义</h4>
            <p>【链路唯一性】转仓链路唯一限制为下单货主+下单货主运营项目+客户要求送货区域+末级租户</p>
            <p>【下单货主运营项目】您可选择多个下单货主的运营项目；若您不选择运营项目，则没有命中运营项目的链路将优先归集至此链路下</p>
            <p>【收货区域】按客户配送收货地市一级维度进行选择（可多选）；若您不选择配送区域，则没有命中送货区域的链路优先归集至此链路下</p>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="handleClose">
          取消
        </el-button>
        <el-button
          v-loading="loading.submitData"
          :disable="loading.submitData"
          type="primary"
          @click="handleSubmit"
        >
          <!-- {{ activeName === '1' ? '保存并下一步' : '确 定' }} -->
          确 定
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  warehouseTransferCreate, getCustomerList, warehouseTransferUpdate, getContractAllTypeList, warehouseBindCondition, projectList, warehouseTransferDetail,
} from '@/api/configure/ownerRule';
import { getTenantList } from '@/api/carrierManagement';
import { processingSelectData } from '@/utils/index';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import AddressCity from '@/components/Address/index.vue';
import { warehouseOptions, tranWareFieldWareHouse, tableColumn } from '../constant';
import formItem from '../../components/formItem.vue';

export default {
  name: 'AddRollOver',
  components: {
    formItem,
    AddressCity,
  },
  props: {
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tranWareFieldWareHouse,
      tableColumn,
      dialogTitle: '新增转仓路径',
      dialogVisible: false,
      loading: {
        submitData: false,
      },
      form: {},
      customerOptions: [],
      originalCustomerOptions: [],
      projectList: [],
      userInfo: localStorageGet(USER),
      customerCodeID: '',
      project: [],
      areas: [],
      originalCustomerID: '',
      tenantOptions: [],
      // showTenantOptions: [],
      originalCustomer: false,
      editLoading: false,
      cityList: [],
      // 合同
      contractObj: [],
      projectObj: [],
      activeName: '1',
      isChange: false,
    };
  },
  computed: {
    warehouseOptions() {
      return processingSelectData(warehouseOptions).reverse();
    },
    plusFun() {
      return (index) => {
        let isTrue = false;
        if (this.originalCustomer) {
          isTrue = this.form.warehouseTransferRuleList.length > 1 && index + 1 === this.form.warehouseTransferRuleList.length - 1 && index < 5;
        } else {
          isTrue = this.form.warehouseTransferRuleList.length > 1 && index + 1 === this.form.warehouseTransferRuleList.length && index < 6;
        }
        return isTrue;
      };
    },
    cancelFun() {
      return (index) => {
        let isTrue = false;
        if (this.originalCustomer) {
          isTrue = this.form.warehouseTransferRuleList.length > 2 && index !== 0 && index + 1 !== this.form.warehouseTransferRuleList.length;
        } else {
          isTrue = this.form.warehouseTransferRuleList.length > 2 && index !== 0;
        }
        return isTrue;
      };
    },
  },
  methods: {
    handleClick() {
    },
    getCity(cityList, params) {
      const cityParam = params;
      cityList.forEach((item) => {
        cityParam[item.value] = item.label;
        if (item.children) {
          this.getCity(item.children, cityParam);
        }
      });
      return cityParam;
    },
    changeCity(value) {
      const { cityList, val } = value;
      const cityParams = this.getCity(cityList, {});
      const areaReqList = [];
      val.forEach((item) => {
        areaReqList.push({
          province: cityParams[item[0]],
          provinceCode: item[0],
          city: cityParams[item[1]],
          cityCode: item[1],
          allCity: !item[1],
        });
      });
      this.form = {
        ...this.form,
        areaReqList,
        // province: address.provinceName || undefined,
        // provinceCode: address.provinceCode || undefined,
        // city: address.cityName || undefined,
        // cityCode: address.cityCode || undefined,
        ext: {
          ...this.form.ext,
          // provinceCode: address.provinceCode || undefined,
          // cityCode: address.cityCode || undefined,
          // city: address.cityName || undefined,
          // province: address.provinceName || undefined,
        },
      };
    },
    async init(row = {}, isEdit) {
      console.log('customersDetail--', this.customersDetail);
      console.log('row--', row);
      const { id } = this.customersDetail;
      this.editLoading = true;
      this.contractObj = [];
      this.activeName = '1';
      this.isChange = false;
      this.tenantOptions = [];
      this.areas = [];
      this.project = [];
      if (row.id) {
        this.dialogTitle = '编辑转仓路径';
        const { ext } = row;
        this.customerCodeID = ext && ext.customerId ? ext.customerId : null;
        this.originalCustomerID = ext && ext.originalCustomerId ? ext.originalCustomerId : null;
        // this.areas = ext && ext.provinceCode ? [[ext.provinceCode, ext.cityCode]] : [];
        for (let i = 0; i < row.warehouseTransferRuleList.length; i += 1) {
          this.contractObj.push({
            contractList: row.warehouseTransferRuleList[i].contractCode ? [{
              contractCode: row.warehouseTransferRuleList[i].contractCode,
              contractName: row.warehouseTransferRuleList[i].contractName,
            }] : [],
          });
          this.projectObj.push({
            projectList: row.warehouseTransferRuleList[i].projectId ? [{
              projectId: row.warehouseTransferRuleList[i].projectId,
              projectName: row.warehouseTransferRuleList[i].projectName,
            }] : [],
          });
        }
        this.$set(this, 'form', JSON.parse(JSON.stringify({
          ...row,
          areaReqList: row.warehouseTransferAreaList,
          projectReqList: row.warehouseTransferProjectList,
        })));
        if (!ext) {
          this.$set(this.form, 'ext', {});
        }
      } else {
        this.originalCustomer = false;
        this.dialogTitle = '新增转仓路径';
        this.customerCodeID = id;
        this.originalCustomerID = null;
        this.form = {
          type: 'DELIVER_STORE',
          warehouseTransferRuleList: [
            { tenantId: '', sort: 1 },
            { tenantId: '', sort: 2 },
          ],
          ext: {},
        };
        this.contractObj = [
          { contractList: [] },
          { contractList: [] },
        ];
        this.projectObj = [
          { projectList: [] },
          { projectList: [] },
        ];
      }
      this.dialogVisible = true;
      // await this.querySearchAsync(this.customerCodeID ? row : '', this.customerCodeID || '', true, row.customerCode);
      await this.handleCustomerSelect(id, isEdit);
      await this.queryOriginalCustomer(this.originalCustomerID ? row.originalCustomerName : '', this.originalCustomerID || '', row.ext && row.ext.originalCustomerCode ? row.ext.originalCustomerCode : '');
      await this.querySearchTenantAsync();
      this.editLoading = false;
      if (row.id) {
        const areas = [];
        row.warehouseTransferAreaList.forEach((item) => {
          if (item.allCity) {
            areas.push([item.provinceCode]);
          } else {
            areas.push([item.provinceCode, item.cityCode]);
          }
        });
        const project = [];
        row.warehouseTransferProjectList.forEach((item) => {
          project.push(`${item.projectId}`);
        });
        this.areas = areas;
        this.project = project;
      }
    },
    handelDeleteLine(i) {
      this.isChange = true;
      this.deleteLine(i);
    },
    deleteLine(i) {
      this.form.warehouseTransferRuleList.splice(i, 1);
      if (this.originalCustomer) {
        const index = this.form.warehouseTransferRuleList.length;
        this.form.warehouseTransferRuleList[index - 1].contractCode = '';
        this.form.warehouseTransferRuleList[index - 1].contractName = '';
        this.handleFocus(index - 1);
      }
      this.contractObj.splice(i, 1);
    },
    handelAddLine() {
      this.isChange = true;
      this.addLine();
    },
    addLine() {
      if (this.originalCustomer) {
        this.form.warehouseTransferRuleList.splice(-1, 0, {
          tenantId: '',
          tenantName: '',
          sort: this.form.warehouseTransferRuleList.length,
        });
        const index = this.form.warehouseTransferRuleList.length;
        this.form.warehouseTransferRuleList[index - 1].sort = index + 1;
        this.form.warehouseTransferRuleList[index - 1].contractCode = '';
        this.form.warehouseTransferRuleList[index - 1].contractName = '';
        this.contractObj.splice(index - 2, 0, {
          contractList: [],
        });
        this.contractObj.splice(index - 1, 1, {
          contractList: [],
        });
        this.handleFocus(index - 1);
      } else {
        this.form.warehouseTransferRuleList.push({
          tenantId: '',
          tenantName: '',
          sort: this.form.warehouseTransferRuleList.length + 1,
        });
        this.contractObj.push({
          contractList: [],
        });
        this.projectObj.push({
          projectList: [],
        });
      }
    },
    filterLine(len, i) {
      if (len > 2 && len - 1 === i) {
        return true;
      }
      return false;
    },
    handleClose() { this.dialogVisible = false; },
    async handleSubmit() {
      this.isRepet = false;
      this.isConfigTenant = true;
      let isContract = true;
      // let isProject = true;
      const data = {};
      this.form.warehouseTransferRuleList.forEach((item, index) => {
        if (!item.tenantId) this.isConfigTenant = false;
        if (!item.contractCode) {
          isContract = false;
        }
        // if (!item.projectId) {
        //   isProject = false;
        // }
        if (this.originalCustomer && this.form.warehouseTransferRuleList.length - 1 === index) return;
        if (data[item.tenantId]) {
          this.isRepet = true;
        } else {
          data[item.tenantId] = item.tenantId;
        }
      });
      if (!this.form.customerCode) {
        this.$message.warning('配置转仓关系客户不能为空!');
        return;
      }
      if (!this.isConfigTenant) {
        this.$message.warning('配置转仓关系租户不能为空!');
        return;
      }
      const allLength = this.form.warehouseTransferRuleList.length;
      if (allLength !== 2 && !isContract) {
        this.$message.warning('请选择合同!');
        return;
      }
      // if (allLength !== 2 && !isProject) {
      //   this.$message.warning('请选择运营项目!');
      //   return;
      // }
      if (allLength === 2) {
        const t1 = this.form.warehouseTransferRuleList[0];
        const t2 = this.form.warehouseTransferRuleList[1];
        if (t1.tenantId === t2.tenantId && !t1.contractCode) {
          this.$message.warning('请选择合同!');
          return;
        }
        if (t1.tenantId !== t2.tenantId && !isContract) {
          this.$message.warning('请选择合同!');
          return;
        }
        // if (t1.tenantId !== t2.tenantId && !isProject) {
        //   this.$message.warning('请选择运营项目!');
        //   return;
        // }
      }
      if (allLength !== 2 && this.isRepet) {
        this.$message.warning('结算链路中出现重复的租户!');
        return;
      }
      if (!allLength > 2) {
        this.$message.warning('配置转仓关系至少需要两个租户!');
        return;
      }
      let creditCode = '';
      if (this.form.originalCustomerCode) {
        creditCode = this.form.originalCustomerCreditCode || '';
      } else if (this.form.customerCode) {
        creditCode = this.form.customerCreditCode || '';
      }
      if (!creditCode) {
        this.$message.error('企业信用代码未找到，不能配置转仓!');
        return;
      }
      const { areaReqList = [], projectReqList = [], ...resetParams } = this.form;
      if (this.activeName === '1') {
        this.isChange = false;
        const params = {
          ...resetParams,
          creditCode,
        };
        if (this.form.id) {
          params.operateUserId = this.userInfo.userId;
          params.operateUserName = this.userInfo.realName;
        } else {
          params.createUserId = this.userInfo.userId;
          params.createUserName = this.userInfo.realName;
        }
        this.loading.submitData = true;
        const request = this.form.id ? warehouseTransferUpdate : warehouseTransferCreate;
        try {
          if (params.updateTime) {
            delete params.updateTime;
          }
          const res = await request({
            ...params,
          });
          this.$message.success(this.form.id ? '更新成功！' : '新增成功');
          if (!this.form.id) {
            this.form.id = res;
            this.$set(this.form, 'id', res);
          }
          this.loading.submitData = false;
          const row = await warehouseTransferDetail({
            id: this.form.id,
          });
          this.form = {
            ...row,
            ...this.form,
          };
          this.$emit('refer');
          this.dialogVisible = false;
          // this.activeName = '2';
        } catch (error) {
          this.loading.submitData = false;
        }
      } else {
        await warehouseBindCondition({
          transferId: this.form.id,
          areaReqList,
          projectReqList,
        });
        this.dialogVisible = false;
        this.loading.submitData = false;
        this.$emit('refer');
      }
    },
    async querySearchAsync(queryString, id, tag) {
      const flag = Object.prototype.toString.call(queryString) === '[object Object]';
      let query = '';
      if (!flag) {
        query = queryString;
      } else {
        query = queryString.customerName;
      }
      // 搜索客户
      const data = {
        customerNameAndCreditCode: query,
        isQueryAll: true,
        ignoreTenant: true,
      };
      const res = await getCustomerList({ ...data }, {
        page: 1,
        size: 100,
      });
      if (res.records && res.records.length > 0) {
        this.customerOptions = res.records.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.customerName} (${e.carrierTenantName})`,
        }));
      } else {
        // eslint-disable-next-line no-lonely-if
        if (flag) {
          const newRes = await getCustomerList({
            ...data,
            customerNameAndCreditCode: '',
            customerCode: queryString.customerCode,
          }, {
            page: 1,
            size: 100,
          });
          this.customerOptions = newRes.records && newRes.records.length > 0 ? newRes.records.map((e) => ({
            ...e,
            value: e.id,
            label: `${e.customerName} (${e.carrierTenantName})`,
          })) : [];
        } else {
          this.customerOptions = [];
        }
      }
      if (id) {
        this.handleSelect(id, tag);
      }
    },
    async queryOriginalCustomer(queryString, id, originalCustomerCode) {
      // 查询原始客户
      const res = await getCustomerList({
        customerNameAndCreditCode: queryString,
        isQueryAll: true,
        ignoreTenant: true,
      }, {
        page: 1,
        size: 100,
      });
      if (res.records && res.records.length > 0) {
        const data = res.records.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.customerName} (${e.carrierTenantName})`,

        }));
        this.originalCustomerOptions = data;
      } else if (!originalCustomerCode) {
        this.originalCustomerOptions = [];
      } else {
        const newRes = await getCustomerList({
          customerCode: originalCustomerCode,
          isQueryAll: true,
          ignoreTenant: true,
        }, {
          page: 1,
          size: 100,
        });
        this.originalCustomerOptions = newRes.records && newRes.records.length > 0 ? newRes.records.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.customerName} (${e.carrierTenantName})`,
        })) : [];
      }
      if (id) {
        this.handleOriginalSelect(id, true);
      }
    },
    async getProjectList() {
      const res = await projectList({
        customerCode: this.form.customerCode,
        tenantId: this.form.tenantId,
        source: 'OWN',
        status: 'ENABLE',
      }, {
        page: 1,
        size: 1000,
      });
      this.projectList = res.records;
    },
    async querySearchTenantAsync(queryString) {
      // 查询租户，企业客户名称
      const res = await getTenantList({
        tenantNameLike: queryString || '_',
      });
      if (res && res.length > 0) {
        const data = res.map((e) => ({
          ...e,
          value: e.tenantId,
          label: e.tenantName,
        }));
        this.tenantOptions = data.slice(0, 100);
      } else {
        this.tenantOptions = [];
      }
    },
    async querySearchContract(query, index) {
      // 查询合同
      const id = this.form.warehouseTransferRuleList[index].tenantId;
      let params = {};
      if (index === 0) {
        // 第一层：客户是甲方，当前是乙方
        params = {
          partBTenantId: id,
          needAllContracts: true,
          contractScenes: ['STORAGE'],
          cargoOwnerCode: this.form.customerCode,
          customerCode: this.form.originalCustomerCode,
        };
      }
      if (index > 0) {
        // 自己是乙方，上一次是甲方
        params = {
          partBTenantId: id,
          needAllContracts: true,
          contractScenes: ['STORAGE'],
          cargoOwnerCode: this.form.warehouseTransferRuleList[index - 1].tenantId,
          customerCode: this.form.originalCustomerCode,
        };
      }
      if (!params.cargoOwnerCode) {
        this.$message.warning('请先选择上一行企业货主名称');
        return;
      }
      const { STORAGE } = await getContractAllTypeList(params);
      this.contractObj.splice(index, 1, {
        contractList: STORAGE || [],
      });
    },
    chooseContractChange(id, index) {
      this.isChange = true;
      this.chooseContract(id, index);
    },
    chooseContract(id, index) {
      // 选择合同
      const item = this.contractObj[index].contractList.find((t) => t.contractCode === id);
      this.form.warehouseTransferRuleList = this.form.warehouseTransferRuleList.map((t) => {
        if (t.contractCode === id) {
          return { ...t, contractCode: id, contractName: item.contractName };
        }
        return { ...t };
      });
    },
    handleContractFocus(index) {
      // 合同聚焦
      this.querySearchContract('', index);
    },
    handleFocus(index) {
      this.tenantOptions = [];
      this.querySearchTenantAsync(this.form.warehouseTransferRuleList[index].tenantName);
      this.querySearchProject(this.form.warehouseTransferRuleList[index].projectName, index, this.form.warehouseTransferRuleList[index].projectId);
    },
    handleCustomerSelect(id, isEdit) {
      this.isChange = true;
      this.handleSelect(id, isEdit);
    },
    handleSelect(id, tag) {
      // const data = this.customerOptions.filter((item) => item.value === id)[0];
      const data = this.customersDetail;
      this.form.customerName = data ? data.customerName : '';
      this.form.customerCode = data ? data.customerCode : '';
      this.form.tenantId = data ? data.carrierTenantId : '';
      this.form.tenantName = data ? data.carrierTenantName : '';
      this.form.customerCreditCode = data ? (data.creditCode || '') : '';
      this.$set(this.form.ext, 'customerId', data ? data.id : '');
      this.form.ext = {
        ...this.form.ext,
        customerId: data ? data.id : '',
      };
      this.getProjectList();
      if (!tag) {
        this.form.warehouseTransferRuleList[0].tenantId = data ? data.carrierTenantId : '';
        this.form.warehouseTransferRuleList[0].tenantName = data ? data.carrierTenantName : '';
        // 客户切换，所有客户将清空
        this.form.warehouseTransferRuleList.forEach((t) => {
          // eslint-disable-next-line no-param-reassign
          t.contractCode = ''; t.contractName = '';
        });
        this.contractObj.forEach((t) => {
          // eslint-disable-next-line no-param-reassign
          t.contractList = [];
        });
      }
      this.handleFocus(0);
    },
    handleProjectSelect(val) {
      const chooseList = this.projectList.filter((item) => val.includes(`${item.id}`));
      const projectReqList = [];
      chooseList.forEach((item) => {
        projectReqList.push({
          projectId: item.id,
          projectName: item.projectName,
        });
      });
      this.$set(this.form, 'projectReqList', projectReqList);
    },
    handelChangeType() {
      this.isChange = true;
    },
    handleOriginalChange(id) {
      this.isChange = true;
      const warehouseTransferRuleList = [];
      this.form.warehouseTransferRuleList.forEach((item) => {
        warehouseTransferRuleList.push({
          ...item,
          contractCode: '',
          contractName: '',
          projectId: '',
          projectName: '',
        });
      });
      this.form.warehouseTransferRuleList = warehouseTransferRuleList;
      this.handleOriginalSelect(id);
    },
    handleOriginalSelect(id, init = false) {
      // 选择原始客户
      if (id) {
        const data = this.originalCustomerOptions.filter((item) => item.value === id)[0];

        if (!this.form.originalCustomerCode && !init) {
          this.form.warehouseTransferRuleList.push({
            tenantId: data ? data.carrierTenantId : '',
            tenantName: data ? data.carrierTenantName : '',
            contractCode: '',
            contractName: '',
            projectId: '',
            projectName: '',
            sort: this.form.warehouseTransferRuleList.length + 1,
          });
          if (this.form.warehouseTransferRuleList.length !== this.contractObj.length) {
            this.contractObj.push({ contractList: [] });
          }
        }
        const index = this.form.warehouseTransferRuleList.length;
        this.form.originalCustomerName = data && data.customerName ? data.customerName : '';
        this.form.originalCustomerCode = data ? data.customerCode : '';
        this.form.originalCustomerCreditCode = data ? data.creditCode : '';
        this.form.ext.originalCustomerCode = data ? data.customerCode : '';
        this.form.ext.originalCustomerId = data ? data.id : '';
        if (!init) {
          this.$set(this.form.warehouseTransferRuleList[index - 1], 'tenantId', data ? data.carrierTenantId : '');
          this.$set(this.form.warehouseTransferRuleList[index - 1], 'tenantName', data ? data.carrierTenantName : '');
        }
        this.handleFocus(index - 1);
        this.originalCustomer = true;
      } else {
        this.originalCustomerID = null;
        this.form.originalCustomerName = '';
        this.form.originalCustomerCode = '';
        this.form.ext.originalCustomerCode = '';
        this.form.ext.originalCustomerId = '';
        const index = this.form.warehouseTransferRuleList.length - 1;
        this.originalCustomer = false;
        this.deleteLine(index);
        if (this.form.warehouseTransferRuleList.length === 1) {
          this.addLine();
        }
      }
      // 原始合同切换，除了第一条数据，其余合同均清空
      if (!init) {
        this.form.warehouseTransferRuleList.forEach((t, newIndex) => {
          if (newIndex > 0) {
            // eslint-disable-next-line no-param-reassign
            t.contractCode = ''; t.contractName = '';
          }
        });
        this.contractObj.forEach((t, newIndex) => {
          if (newIndex > 0) {
            // eslint-disable-next-line no-param-reassign
            t.contractList = [];
          }
        });
      }
    },
    lineSelectChange(id, index) {
      this.isChange = true;
      this.lineSelect(id, index);
    },
    lineSelect(id, index) {
      const data = this.tenantOptions.filter((item) => item.value === id)[0];
      this.form.warehouseTransferRuleList[index].contractCode = '';
      this.form.warehouseTransferRuleList[index].contractName = '';
      // this.querySearchContract('', index);
      this.form.warehouseTransferRuleList = this.form.warehouseTransferRuleList.map((item) => {
        if (item.tenantId === id) {
          return { ...item, tenantName: data.tenantName };
        }
        return { ...item };
      });
    },
    async querySearchProject(query, index, id) {
      let customerCode = '';
      let tenantId = '';
      if (index === 0) {
        console.log('warehouseTransferRuleList-0--', this.form.warehouseTransferRuleList[index]);
        customerCode = this.form.customerCode;
        tenantId = this.form.tenantId;
      } else {
        console.log('warehouseTransferRuleList-A--', this.form.warehouseTransferRuleList[index - 1]);
        console.log('warehouseTransferRuleList-B--', this.form.warehouseTransferRuleList[index]);
        customerCode = this.form.warehouseTransferRuleList[index - 1].tenantId;
        tenantId = this.form.warehouseTransferRuleList[index].tenantId;
      }
      const params = {
        customerCode,
        tenantId,
        source: 'OWN',
        status: 'ENABLE',
        bizTypes: ['WAREHOUSE', 'TRANSPORT_WAREHOUSE'],
      };
      if (id) {
        params.id = id;
      } else {
        params.projectName = query || undefined;
      }
      const res = await projectList(params, {
        page: 1,
        size: 20,
      });
      this.projectObj.splice(index, 1, {
        projectList: res?.records?.map((p) => {
          const project = {
            ...p,
            projectId: p.id,
          };
          return project;
        }) ?? [],
      });
    },
    handleChangeProject(val, index) { // 切换运营项目
      if (val) {
        const current = this.projectObj[index].projectList.find((t) => t.projectId === val);
        this.$set(this.form.warehouseTransferRuleList[index], 'projectName', current.projectName);
      } else {
        this.$set(this.form.warehouseTransferRuleList[index], 'projectName', undefined);
      }
    },
    handleProjectFocus(index) { // 运营项目
      if (this.projectObj[index].projectList?.length) return;
      this.querySearchProject('', index);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.tranWare_dialog_content{
  margin-bottom: 42px;
  .el-form-item{
    .el-form-item__label{
      text-align: left;
    }
  }
  .el-form-item__content{
    .el-select{
      width: 100%;
    }
  }
  .tran_radio{
    display: flex;
    .el-radio{
      margin-left: 0;
      margin-right: 16px;
    }
  }
  .tran_ware_path{
    width: 100%;
  }
  .tran_table{
    margin-bottom: 10px;
    .el-table__body-wrapper{
      .el-select{
      width: 100%;
    }
    }
  }
}
.add_bar{
  height: 36px;
  cursor: pointer;
  width: 100%;
  border:1px dashed #1890FF;
  color: #1890FF;
  display: flex;
  align-items: center;
  justify-content: center;
  span{
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    .el-icon-plus{
      margin-right: 10px;
    }
  }
  &:hover{
    border-color: #5DB1FF;
    color: #5DB1FF;
  }
  &:active{
    border-color: #1373CC;
    color: #1373CC;
  }
}
.dialog-footer{
  width: calc(100% - 48px);
  border-top: 1px solid #EBECEE;
  background: #fff;
  text-align: right;
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 99;
  padding: 12px 24px;
}
.custom-select{
  .customerCodeText{
    margin-left: 12px;
    font-size: 12px;
    color: #ccc;
  }
}
::v-deep .el-cascader{
  width:100%;
}
.city-area {
  margin-bottom: 0;
}
.margin {
  margin-top: 12px;
}
.link_footer {
  font-size: 14px;
}
</style>
